// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n\n/** 存放自定义的变量，可全局直接使用 */\n\n/** 主题色 */\n\n/** 字体样式 */\n\n/** 边框样式 */\n\n/** 错误样式 */\n\n/** 警告样式 */\n\n/** 可复用的模块化样式 */\n\n/**\n * 设置多行文本超出隐藏\n * $n 为规定多少行\n*/\n.nameWrap[data-v-344defac] {\n  font-size: 0.078125rem;\n  padding: 0.052083rem 0 0.052083rem 0.208333rem;\n}\n.contentWrap[data-v-344defac] {\n  margin-top: 0.052083rem;\n  padding: 0 0 0.052083rem 0.208333rem;\n}", ""]);
// Exports
module.exports = exports;
